// Bunker Hill TARP / escalation ladder seed — three illustrative ladders [syn]
// (tarp.A5 / tarp.A6). Attached to diagnostic rules; cases carry position.

import type { EscalationLadder } from '@/versions/v1/schema/escalation-ladder';

export const ESCALATION_LADDERS: readonly EscalationLadder[] = [
  {
    id: 'lad-zn-cuso4',
    ruleId: 'dr-cuso4',
    source: 'tarp',
    tiers: [
      {
        tier: 1,
        role: 'operator',
        instruction: 'check CuSO₄ dosing pump stroke and FIT',
        timeLimitMinutes: 30,
        escalatesTo: 'cro',
      },
      {
        tier: 2,
        role: 'cro',
        instruction: 'arrange CuSO₄ solution-strength titration',
        timeLimitMinutes: 120,
        escalatesTo: 'metallurgist',
      },
      {
        tier: 3,
        role: 'metallurgist',
        instruction: 'interpret titration, adjust dose or change solution batch',
        timeLimitMinutes: 240,
        escalatesTo: 'superintendent',
      },
      {
        tier: 4,
        role: 'superintendent',
        instruction: 'reagent supplier and batch review',
        timeLimitMinutes: 480,
      },
    ],
  },
  {
    id: 'lad-zn-ph',
    ruleId: 'dr-zn-ph',
    source: 'tarp',
    tiers: [
      {
        tier: 1,
        role: 'operator',
        instruction: 'confirm AIC5002 in auto and lime SP',
        timeLimitMinutes: 20,
        escalatesTo: 'cro',
      },
      {
        tier: 2,
        role: 'metallurgist',
        instruction: 'lime demand and pH probe check',
        timeLimitMinutes: 120,
        escalatesTo: 'superintendent',
      },
      {
        tier: 3,
        role: 'superintendent',
        instruction: 'lime supply and circuit review',
        timeLimitMinutes: 240,
        escalatesTo: 'gm',
      },
    ],
  },
  {
    id: 'lad-grind-hardness',
    ruleId: 'dr-hardness',
    source: 'tarp',
    tiers: [
      {
        tier: 1,
        role: 'operator',
        instruction: 'confirm JT-023 kW/tph rise against WIT-021 feed and pull a PSA sample',
        timeLimitMinutes: 30,
        escalatesTo: 'cro',
      },
      {
        tier: 2,
        role: 'cro',
        instruction: 'reduce feed rate 10 % until PSA recovers',
        feedRateChangePct: -10,
        timeLimitMinutes: 60,
        escalatesTo: 'metallurgist',
      },
      {
        tier: 3,
        role: 'metallurgist',
        instruction: 'confirm the ore change and advise the mine planner of the zone',
        timeLimitMinutes: 240,
        escalatesTo: 'superintendent',
      },
      {
        tier: 4,
        role: 'superintendent',
        instruction: 'mine plan and blend review with dispatch',
        timeLimitMinutes: 480,
      },
    ],
  },
];

export const LADDER_BY_ID = new Map(ESCALATION_LADDERS.map((row) => [row.id, row]));
export const LADDER_BY_RULE_ID = new Map(ESCALATION_LADDERS.map((row) => [row.ruleId, row]));
